/**
 * Map-edit from a feature table should fill the viewport so vertices
 * and Save/Cancel stay on screen on mobile or when the table is scrolled.
 */
export function ensureMapMaximized({ mapMaximized, onToggleMapMaximize } = {}) {
  if (mapMaximized) return false;
  if (typeof onToggleMapMaximize !== 'function') return false;
  onToggleMapMaximize();
  return true;
}
